import { usePublicApi } from "api/setup";
import { ApiError } from "api/shared";
import { UseAxiosResult } from "axios-hooks";
import formatUrl from "utils/formatUrl";

import api from "config/urls/api";

export const useQueueDataRefreshMutation = (
  companyId: string,
  manual = true
): UseAxiosResult<unknown, ApiError> => {
  return usePublicApi<unknown, ApiError>(
    {
      url: formatUrl(api.companies.refresh.all, { companyId }),
      method: "POST",
    },
    {
      manual,
    }
  );
};
